import React from 'react';
import { Modal, useTheme } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import Button from '../Button/Button';
import {
  ButtonWrapper,
  ContentWrapper,
  CloseIconButton,
  DescriptionWrapper,
  MainContainer,
  ContentStyledBox,
} from './Style/ConfirmationModalV2.style';
import Title from '../Title/Title';
import { ConfirmationModalProps } from '../../types/ConfirmationModalTypes';

const ConfirmationModalV2: React.FC<ConfirmationModalProps> = ({
  open,
  title,
  description,
  confirmLabel,
  cancelLabel,
  handleCancel,
  handleConfirm,
  handleClose,
  confirmButtonSX,
  cancelButtonnSX,
}) => {
  const theme = useTheme();
  const ConfirmButtonStyle = {
    color: theme.palette.background.default,
    whiteSpace: 'nowrap' as const,
    background: theme.palette.warning.main,
    '&:hover': {
      background: theme.palette.warning.dark,
    },
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <MainContainer>
        <ContentWrapper>
          <Title size="small" title={title} />
           <CloseIconButton
             onClick={handleClose}
             aria-label="close"
           >
            <CancelOutlinedIcon
              sx={{ height: 18, width: 18, color: 'text.primary' }}
            />
          </CloseIconButton>
        </ContentWrapper>
        <ContentStyledBox>
          <DescriptionWrapper>{description}</DescriptionWrapper>
          <ButtonWrapper>
            <Button
              onClick={handleConfirm}
              variant="contained"
              label={confirmLabel}
              sx={{
                ...ConfirmButtonStyle,
                flex: confirmButtonSX ?? 1,
              }}
            />
            <Button
              variant="outlined"
              sx={{
                ...cancelButtonnSX,
                flex: cancelButtonnSX ?? 1,
              }}
              onClick={handleCancel}>
              {cancelLabel}
            </Button>
          </ButtonWrapper>
        </ContentStyledBox>
      </MainContainer>
    </Modal>
  );
};

export default ConfirmationModalV2;